module.exports = __webpack_public_path__ + "static/img/repast01.ab39aaef.jpg";